import { Component, OnInit,  ViewChild , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { ICountryContentStatus, ICountryDataList } from "../../interfaces/icountrycontentstatus";
import { CountryDataStatus } from "../../enums/countrydatastatus";
import { DataExportService } from "../../services/dataexport.service";
import { CountryService } from "../../services/country.service";
import { DownloadFileComponent } from "../downloadfile/downloadfile.component";
import { ToastrService } from "ngx-toastr";
import { CountriesFilterPipe } from "../../pipes/countriesfilter.pipe";
import { UserRoleToggleDirective } from "../../directives/userroletoggle.directive";
import { ImportFileComponent } from "../downloadfile/importFile.component";
import { ConfirmationCountryModalComponent } from "../confirmationcountrydialogmodal/confirmationcountrydialogmodal.component";
import { ConfirmationCountryContentModalComponent } from "../confirmationcountrycontentdialogmodal/confirmationcountrycontentdialogmodal.component";
import { WorkflowStageDataStatusComponent } from "../workflow/workflowstagedatastatus/workflowstagedatastatus.component";


@Component({
    selector: "countryselection",
    standalone: true,
    imports: [CommonModule, FormsModule, RouterModule, CountriesFilterPipe, UserRoleToggleDirective, DownloadFileComponent, ImportFileComponent, ConfirmationCountryModalComponent, ConfirmationCountryContentModalComponent, WorkflowStageDataStatusComponent],
    templateUrl: "./countryselection.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CountrySelectionComponent implements OnInit {
    countryDataStatus : any = CountryDataStatus;
    allCountries: ICountryContentStatus[] = new Array();
    searchTerm: string;
    confirmationMessage: string;
    hasLiveData: boolean;
    isAdminOrSuperAdmin: boolean;
    isSuperAdmin: boolean;
    result: string[];
    statusParameter: string;
    countryID: string;
    @ViewChild("download") fileDownload: DownloadFileComponent;
    @ViewChild("confirmationcountrydialogmodal") confirmationcountrydialogmodal: ConfirmationCountryModalComponent;
    @ViewChild("confirmationcountrycontentdialogmodal") confirmationcountrycontentdialogmodal: ConfirmationCountryContentModalComponent;
    constructor(
        private toastr: ToastrService,
        private activatedRoute: ActivatedRoute,
        private dataExportService: DataExportService,
        private countryService: CountryService  ) {
    }

    ngOnInit(): void {
        
        const countriesData: any = this.activatedRoute.snapshot.data["countries"];
        countriesData.data['map']((e: ICountryContentStatus) => {
             this.allCountries.push(e);
        });
        this.hasLiveData = countriesData.hasLiveData;
        this.isAdminOrSuperAdmin = countriesData.isAdminOrSuperAdmin;
        this.isSuperAdmin = countriesData.isSuperAdmin;
    }

    downloadCountryStatusReport(): void {
        this.dataExportService.getCountryStatusExport().subscribe((res: any) => {
                this.fileDownload.downloadExcel("CountryStatusExport", res);
        }, () => this.toastr.error("An error occurred while exporting the country status report"));
    }

    downloadCountryData(): void {
        this.dataExportService.getCountryData().subscribe((res: any) => {
                this.fileDownload.downloadExcel("CountryLiveDataExport", res);
        }, () => this.toastr.error("An error occurred while exporting country data"));
    }
    downloadCountryDraftData(): void {
        this.dataExportService.getCountryLiveandDraftData().subscribe((res: any) => {
                this.fileDownload.downloadExcel("CountryLiveandDraftDataExport", res);
        }, () => this.toastr.error("An error occurred while exporting country data"));
    }

    downloadTemplateFile(): void {
        this.dataExportService.getImportTemplate().subscribe((res: any) => {
                this.fileDownload.downloadExcel("DataImportTemplate", res);
        }, () => this.toastr.error("An error occurred while exporting the data import template"));
    }

    refreshCountry(): void {
         this.countryService.getCountriesWithContentStatus()
            .subscribe(res => {
                this.allCountries = res.data;
            });
    }

    
    disableEnableCountry(status: string) {
        
        this.result = status.split("$"); 
        this.statusParameter = status;       
        this.confirmationcountrydialogmodal.confirmationText = this.result[0] == '1' ? "Disabling this country will remove the associated data from the client application. Are you sure you want to proceed?" : "Enabling this country will move this country into Draft state and will be available on the client application only after it is published. Are you sure you want to proceed?";
        this.confirmationcountrydialogmodal.openModal();
    }
    onAccept(): void {
                
        this.confirmationcountrydialogmodal.closeModal();
        this.countryService.putDisableEnableCountries(this.statusParameter).subscribe(res => {
                this.allCountries = res.data;
                this.toastr.success("Country status has been updated!")
            });
    }

    onDecline(): void {
        
        this.confirmationcountrydialogmodal.closeModal();
    }  

    deleteCountryContent(countryID: string) {
        
        this.countryID = countryID;
        this.confirmationcountrycontentdialogmodal.ccConfirmationText = "Deleting this country will remove the associated data from the client application permanently. Are you sure you want to proceed?";
        this.confirmationcountrycontentdialogmodal.openModal();
    }
    onContentDeleteAccept(): void {
        this.confirmationcountrycontentdialogmodal.closeModal();
        this.countryService.removeCountryContent(this.countryID).subscribe(res => {
            this.allCountries = res.data;
            this.toastr.success("Country content has been removed!")
        });
    }

    onContentDeleteDecline(): void {

        this.confirmationcountrycontentdialogmodal.closeModal();
    }  
    
}




